<template>
  <div class="value-widget">
    <h1 class="text-center" :style="'color: ' + (opts.color || 'white') + ';'">{{ opts.value }}{{ options.suffix || '' }}</h1>
  </div>
</template>

<script>

import { get } from 'lodash'

export default {
  name: 'Value',
  props: ["appdata", "options"],

  watch: {
    "appdata.response": function(val) {
      if(Object.keys(val).length > 0) {
        this.opts = {...{
          "value": this.ld.get(val, this.options.module, []).value || 0,
          "color": this.ld.get(val, this.options.module, []).color || 'white'
        }, ...this.options}
      }
    }
  },

  methods: {

  },

  data() {
    return {
      opts: {},
      ld: {
        get: _.get
      },
    }
  }
}
</script>
